module.exports = __webpack_public_path__ + "img/psyc-bg.5885fae4.png";